<div class="dropdown" appClickedOutside (clickOutside)="closeDropdown()" [ngClass]="{'opened': toggle}">
  <button class="dropdown-toggle s-control ph" (click)="toggleDropdown()" [ngClass]="{'active': toggle}">
    @if(selectedItems.length > 0){
    <span class="badge-count">
        {{selectedItems.length}}
      </span>
    }
    {{ title }}
  </button>
  <div class="dropdown-menu ani hover s-right" [ngClass]="customClass">
    <div class="is-search">
      <img [src]="searchIcon">
      <input type="text" (input)="searchInput($event)" [placeholder]="'Search ' + title" class="form-control">
    </div>
    <div class="is-box all">
      <label class="app-checkbox">
        <input type="checkbox" [checked]="isAllChecked()" (change)="onSelectAllChanged($event)" />
        <span></span> Select All
      </label>
      <a class="clear-all" (click)="onClearAll()">Clear All</a>
    </div>
    <ul class="nav">
      @for(item of filterList;track $index){
      <li>
        <label class="app-checkbox">
          <input type="checkbox" [checked]="isChecked(item[displayField] || item[secondarydisplayField])"
            (change)="onItemChecked($event,item,$index)">
          <span></span>
          {{ item[displayField] || '-' }}
        </label>
      </li>

      }

    </ul>
  </div>
</div>